import { Record } from "../../components/record/Record";
import { Records } from "../../components/records/Records";
import { tabs } from "./staffKpistabs";
import { EntityForm } from "../../components/entityForm/EntityForm";
import { Groups } from "../../components/groups/Groups";
import { DetailTabs } from "../../components/detailTabs/DetailTabs";
import { staffKpisOptions } from "./staffKpisOptions";
import { StaffKpisDetailHeader } from "./StaffKpisDetailHeader";

export const fieldsQuery = "*.*";

export const staffKpisRoutes = [
    {
        path: "/staff_subjective_evaluation",
        element: (
            <Records
                entity="staff_subjective_evaluation"
                fieldsQuery={fieldsQuery}
                heightOfHeaders={190}
                options={staffKpisOptions}
            />
        ),
    },
    {
        path: "/staff_subjective_evaluation/:id",
        element: (
            <Record
                entity="staff_subjective_evaluation"
                type="detail"
                fieldsQuery={fieldsQuery}
                options={staffKpisOptions?.groupsOptions}
                body={<DetailTabs tabs={tabs} />}
                header={<StaffKpisDetailHeader />}
            />
        ),
        children: [
            {
                path: "/staff_subjective_evaluation/:id/detail",
                element: <Groups groupsOptions={staffKpisOptions?.groupsOptions} />,
            },
        ],
    },
    {
        path: "/staff_subjective_evaluation/:id/update",
        element: (
            <Record
                entity="staff_subjective_evaluation"
                type="update"
                body={<EntityForm groupsOptions={staffKpisOptions?.groupsOptions} />}
            />
        ),
    },
    {
        path: "/staff_subjective_evaluation/create",
        element: (
            <Record
                entity="staff_subjective_evaluation"
                type="create"
                body={<EntityForm groupsOptions={staffKpisOptions?.groupsOptions} />}
            />
        ),
    },
];
